<!-- MINISITE TITLES -->
<div #eventTitle class="flex flex-col items-center text-white opacity-0" [class]="{'hidden': hideElement()}">

    @for (text of displayTexts() | keyvalue: orderFn; track $index) {
        
        @if (text.key === 'main') {
            <h1 id="title" class="event-title">
                {{text.value}}
            </h1>
        } 

        @else {
            <h3 class="event-subtitle">
                {{text.value}}
            </h3>
        }

    }

</div>
